'use client';

import { useEffect, useState } from 'react';

import { CircularProgressIcon } from '@wwe-portal/ui/components/icons/circular-progress-icon';
import {
  Dialog,
  DialogContent,
  CommonDialogContentLayout,
  ProgressingDialogHead,
} from '@wwe-portal/ui/components/dialog';
import successLogo from '@wwe-portal/ui/assets/images/common/payment-success.webp';

interface BaseDialogState {
  title: string;
  description: string;
}

interface PaymentProcessingDialogState extends BaseDialogState {
  duration: number;
}

export interface ProcessingDialogProps {
  open: boolean;
  status: 'progress' | 'success';
  paymentProgressState?: PaymentProcessingDialogState;
  successState?: BaseDialogState;
  onClose?: () => void;
}

export const ProcessingDialog = ({
  open,
  status,
  paymentProgressState,
  successState,
  onClose,
}: ProcessingDialogProps) => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (status === 'progress') {
      setTimeout(() => {
        setProgress(100);
      });
    }
  }, [status]);

  return (
    <Dialog
      onOpenChange={(value) => {
        if (!value && status === 'success') {
          onClose?.();
        }
      }}
      open={open}
    >
      <DialogContent
        data-id={status === 'progress' ? 'progress-dialog' : 'success-dialog'}
        variant="message"
      >
        {status === 'progress' && paymentProgressState != null && (
          <CommonDialogContentLayout
            actionElement={undefined}
            closable={false}
            descriptionElement={paymentProgressState.description}
            hasBackground
            imageElement={
              <ProgressingDialogHead
                duration={paymentProgressState.duration}
                progressPercent={progress}
              />
            }
            titleElement={paymentProgressState.title}
          />
        )}
        {status === 'success' && successState != null && (
          <CommonDialogContentLayout
            actionElement={undefined}
            closable
            descriptionElement={successState.description}
            hasBackground
            imageElement={
              <div className="relative flex h-full w-full items-center justify-center">
                <img alt="success" src={successLogo} />
                <div className="absolute inset-0">
                  <CircularProgressIcon
                    duration={0}
                    height="100%"
                    progressPercent={100}
                    width="100%"
                  />
                </div>
              </div>
            }
            onClose={onClose}
            titleElement={successState.title}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
